import { getUpdatedFilterValue } from "utils/helpers/string";

const FilterOptions = ({
  filterType,
  filters,
  updateChosenRestaurantFilters,
  router,
  selectedFilters,
}) => {
  return (
    <div className="flex flex-col">
      {filters.map((filter) => (
        <div key={`${filter}${router?.query?.[filterType]?.includes(filter)}`}>
          <label className="select-none inline-flex items-center py-2 text-sm max-w-[170px]">
            <input
              autoComplete="off"
              type="checkbox"
              onChange={(e) =>
                updateChosenRestaurantFilters(filterType, e.target.value, true)
              }
              value={filter}
              checked={
                selectedFilters?.includes(getUpdatedFilterValue(filter)) ??
                false
              }
            />
            <span className="ml-[6px] font-inter-medium text-[14px]">
              {filter}
            </span>
          </label>
        </div>
      ))}
    </div>
  );
};

export default FilterOptions;
